import {
  fetch
} from '@/plugin/axios/index.js'
import formAxios from '@/plugin/axios/formAxios.js'

/**
 * @param {Object} data
 * 银行卡分页列表
 */
export function getCardPageList(data) {
  return fetch({
    url: '/financial/card/pageList',
    method: 'POST',
    data
  })
}


/**
 * @param {Object} data
 * 删除银行卡
 */
export function deleteCard(data) {
  return fetch({
    url: '/financial/card/delete',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 保存银行卡
 */
export function saveCard(data) {
  return fetch({
    url: '/financial/card/save',
    method: 'POST',
    data
  })
}

/**
 * @param {Object} data
 * 列表银行卡
 */
export function getCardList(data) {
  return fetch({
    url: '/financial/card/getCardList',
    method: 'GET',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/Card/index.js